import routes from '@cohort/merchants/router/Routes';
import React from 'react';
import {RouterProvider} from 'react-router-dom';

const Router: React.FC = () => <RouterProvider router={routes} />;

export default Router;
